import axios from "axios";

export const pingBackend = async () => {
  try {
    // 假设您有一个专门用于 ping 的轻量级 API 端点
    await axios.get(import.meta.env.VITE_BACKEND_URL, {
      timeout: 5000,
    });
    return true;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("Ping 后台服务失败:", error);
    if (error?.code === "ERR_NETWORK" || error?.code === "ETIMEDOUT" || error?.code === "ECONNABORTED" ) {
      return false;
    }
    return true;
  }
};

let pingBackendTimer: NodeJS.Timeout;
let offlineSec = 0;
export const listenOnline = ({onlineCb, offlineCb, timeout} :{ onlineCb: (offlineSec: number) => void, offlineCb?: (offlineSec: number) => void, timeout?: number}) => {
  pingBackendTimer && clearInterval(pingBackendTimer);
  pingBackendTimer = setInterval(async () => {
    const online = await pingBackend();
    if (online) {
      onlineCb(offlineSec);
      offlineSec = 0;
      clearInterval(pingBackendTimer);
      return;
    }
    offlineSec += 1;
    offlineCb && offlineCb(offlineSec);
  }, timeout || 1000);
  return ()=> {
    pingBackendTimer && clearInterval(pingBackendTimer);
  }
};
